import PropTypes from 'prop-types'
import React, {useState} from 'react'
import i18n from 'i18next'
import Button from '#components/a/Button'
import IconButton from '#components/a/IconButton'
import Text from '#components/a/Text'
import Headline from '#components/a/Headline'
import ModalByProps from '#components/m/ModalByProps'
import ControlsGroup from '#components/m/ControlsGroup'
import UserSelectionInput from '#components/m/Versetzungsplan/UserSelectionInput'
import Api from '#services/api'
import UnorderedList from '#components/a/UnorderedList'
import actions from 'redux-auto'
import {connect} from 'react-redux'

function CopyAzubiModal({user, azubis, readVersetzungsplan}) {
  const [azubiId, setAzubiId] = useState(azubis[0]?.id)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [viewState, setViewState] = useState('selectAzubi')
  const [missingAbteilungen, setMissingAbteilungen] = useState([])

  function ShowIf({condition, children}) {
    return condition ? children : null
  }

  const getMissingAbteilungen = async () => {
    setMissingAbteilungen(await Api.getMissingAbteilungenForCopy(user.id, azubiId))
  }

  const onCopyVersetzungsplan = async (source, destination) => {
    await Api.copyVersetzungsplan(source.id, destination.id)
    readVersetzungsplan()
  }

  function CopyContent() {
    return (
      <ShowIf condition={viewState === 'selectAzubi'}>
        <Headline modifier="article" importance={2} text={i18n.t('versetzungsplan_copy_modal_header')} />
        <Text modifier="small" text={i18n.t('versetzungsplan_copy_modal_text')} />
        <UserSelectionInput azubis={azubis} selectedAzubiId={azubiId} onSelectAzubi={setAzubiId} />
        <ControlsGroup>
          <Button testid="modalCancelButton" event={() => setShowModal(false)} text="Abbrechen" variant="secondary" />
          <Button
            testid="modalConfirmButton"
            event={async () => {
              setViewState('confirmAzubi')
              await getMissingAbteilungen()
            }}
            text={i18n.t('versetzungsplan_copy_modal_confirm_text')}
            variant="primary"
          />
        </ControlsGroup>
      </ShowIf>
    )
  }

  function UnequalAusbildungsberufHint() {
    const azubiSource = azubis.find(a => a.id === user.id)
    const azubiDestination = azubis.find(a => a.id === azubiId)
    return (
      <ShowIf condition={azubiSource.ausbildungsberuf !== azubiDestination.ausbildungsberuf}>
        <Text
          modifier="small"
          text={i18n.t('versetzungsplan_confirm_modal_unequal_ausbildungsberufe', [
            user.name,
            azubiSource.ausbildungsBerufString,
            azubis.find(a => a.id === azubiId).name,
            azubiDestination.ausbildungsBerufString,
          ])}
        />
      </ShowIf>
    )
  }

  function MissingAbteilungenHint() {
    return (
      <ShowIf condition={missingAbteilungen.length !== 0}>
        <Text
          modifier="small"
          text={i18n.t('versetzungsplan_confirm_modal_missing_abteilungen', [
            user.name,
            azubis.find(a => a.id === azubiId).name,
          ])}
        />
        <UnorderedList items={missingAbteilungen} />
        <Text modifier="small" text={i18n.t('versetzungsplan_confirm_modal_missing_abteilungen_tailing')} />
      </ShowIf>
    )
  }

  function ConfirmContent() {
    return (
      <ShowIf condition={viewState === 'confirmAzubi'}>
        <Headline modifier="article" importance={2} text={i18n.t('versetzungsplan_confirm_modal_header')} />
        <Text
          modifier="small"
          text={i18n.t('versetzungsplan_confirm_modal_text', [user.name, azubis.find(a => a.id === azubiId).name])}
        />
        <UnequalAusbildungsberufHint />
        <MissingAbteilungenHint />
        <ControlsGroup>
          <Button
            testid="modalCancelButton"
            event={() => setViewState('selectAzubi')}
            text={i18n.t('versetzungsplan_confirm_modal_cancel_text')}
            variant="secondary"
          />
          <Button
            testid="modalConfirmButton"
            event={async () => {
              setLoading(true)
              await onCopyVersetzungsplan(user, {id: azubiId})
              setLoading(false)
              setViewState('selectAzubi')
              setShowModal(false)
            }}
            disabled={loading}
            text={i18n.t('versetzungsplan_confirm_modal_confirm_text')}
            variant="primary"
          />
        </ControlsGroup>
      </ShowIf>
    )
  }

  return (
    <div className="copyVersetzungsplan">
      <IconButton icon="copy" event={() => setShowModal(true)} />
      <ModalByProps
        modalIsOpen={showModal}
        modifier={viewState === 'confirmAzubi' ? 'copy-azubi-confirm' : 'copy-azubi'}>
        <CopyContent />
        <ConfirmContent />
      </ModalByProps>
    </div>
  )
}

CopyAzubiModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.any,
    name: PropTypes.any,
  }),
  azubis: PropTypes.array,
  readVersetzungsplan: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    azubis: state.azubis.allAzubis,
  }
}

function mapDispatchToProps() {
  return {
    readVersetzungsplan: actions.versetzungsplan.readVersetzungsplan,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyAzubiModal)
